import api from './api';

export const getDelays = (params = {}) => api.get('/delays/', { params });

export const getDelay = (id) => api.get(`/delays/${id}`);

export const getDelayNotifications = (id) => api.get(`/delays/${id}/notifications`);

export const closeDelay = (id, data) => api.put(`/delays/${id}/close`, data);

export const escalateDelay = (id, level) => api.put(`/delays/${id}/escalate`, level ? { level } : {});

export const getDelayStats = () => api.get('/delays/stats');
